'use client';

import classnames from 'classnames';
import { type FC, Fragment, useState } from 'react';

import Image from 'molecules/Image';
import Link from 'molecules/Link';

import NavMobile from 'components/Header/NavMobile';
import styles from 'components/Header/SiteMobileHeader/site-header-mobile.module.scss';

import useOpenState from 'utils/hooks/useOpenState';

import type { GlobalHeaderProps } from 'components/Header/headerTypes';

export type SiteMobileHeaderProps = GlobalHeaderProps['data'];

const SiteMobileHeader: FC<SiteMobileHeaderProps> = ({ menus = [] }) => {
  const [isExpanded, setIsExpanded] = useOpenState();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleClick = () => {
    if (isExpanded) {
      setOpenIndex(null);
    }
    setIsExpanded(prev => !prev);
  };

  const setOpen = (index: number): void => {
    setOpenIndex(index);
  };

  const closePanels = (): void => {
    setOpenIndex(null);
  };

  return (
    <Fragment>
      <div role="banner" className={styles.mobileHeader} style={{ position: isExpanded ? 'fixed' : 'sticky' }}>
        <Link aria-label="To HomePage" href="/">
          <Image alt="MagMutual Logo" width={175} height={28} url="/magmutual-egg.svg" />
        </Link>
        <button
          onClick={handleClick}
          className={classnames(styles.button, {
            [styles.buttonExpanded]: isExpanded,
          })}
          aria-expanded={isExpanded}
        >
          {isExpanded ? 'Close' : 'Menu'}
        </button>
      </div>
      {isExpanded && (
        <NavMobile
          menus={menus}
          openIndex={openIndex}
          handleClick={handleClick}
          setOpen={setOpen}
          closePanels={closePanels}
        />
      )}
    </Fragment>
  );
};

export default SiteMobileHeader;
